<template>
	<div class="bg-body-secondary rounded-3 p-2 p-md-3 vstack w-100 text-sm lh-sm">
		<span class="text-muted">{{ title }}</span>
		<span class="fw-bold">
			<slot />
		</span>
	</div>
</template>

<script>
	export default {
		props: {
			title: String
		}
	}
</script>